/**
 * Tasks Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const tasksAPI = {
  getAll: (params) => apiClient.get('/tasks', { params }),
  getById: (id) => apiClient.get(`/tasks/${id}`),
  // Backend does not expose /tasks/business/:id; use query param
  getByBusiness: (businessId, params) => apiClient.get('/tasks', { params: { ...(params || {}), business_id: businessId } }),
  getOverdue: (params) => apiClient.get('/tasks/overdue', { params }),
  // Backend does not expose /tasks/priority/:value; use query param
  getByPriority: (priority, params) => apiClient.get('/tasks', { params: { ...(params || {}), priority } }),
  // Backend route is /tasks/upcoming/list
  getUpcoming: (params) => apiClient.get('/tasks/upcoming/list', { params }),
  getStats: (params) => apiClient.get('/tasks/stats/summary', { params }),
  create: (data) => apiClient.post('/tasks', data),
  update: (id, data) => apiClient.put(`/tasks/${id}`, data),
  delete: (id) => apiClient.delete(`/tasks/${id}`),
  patchCompletion: (id, completion_percentage) => apiClient.patch(`/tasks/${id}/completion`, { completion_percentage }),
};

export default tasksAPI;

